

      <div class="modal-header">
        <div class="page-header-button">
          <div class="gb-headline1" id="{{ 'confirmationModalLabel_' + 'id' }}">{{titleText}}</div>
          <button (click)="onClose()" aria-hidden="false"
            attr.aria-label="{{'aoda_close_modal_label' | translate}}"
            class="close-modal web-u {{language}}" type="button">
            <span aria-hidden="true" class="gb-icon-button">
              <span aria-hidden="true" class="icon-ui-close"></span>
            </span>
          </button>
        </div>
      </div>
      <div class="modal-body">
        <p>{{confirmationText}}
          <ng-content></ng-content>
        </p>
      </div>
      <div class="modal-footer">
        <div class="modal-footer-content">
          <span [hidden]="firstOptionHide === true">
            <button (click)="firstOptionCallback()" class="gb-secondary-button mb-2"
              [trackLink]="'ConfirmationModal'"
              prop10="{{pageToTrack}}:button:cancel confirmation {{firstOption}}" 
              [trackDelay]="'this'"
              [trackType]="'o'"
              id="{{firstOptionId}}"
              type="button">{{firstOption}}
            </button>
          </span>
          <span [hidden]="secondOptionHide === true">
            <button (click)="secondOptionCallback()" class="gb-primary-button" 
              [trackLink]="'ConfirmationModal'"
              prop10="{{pageToTrack}}:button:cancel confirmation {{secondOption}}" 
              [trackDelay]="'this'"
              [trackType]="'o'"
              id="{{secondOptionId}}"
              type="button">{{secondOption}}
            </button>
          </span>
        </div>
      </div>
  